export const EntityTranslation = {
  Staff: $localize`Staff`,
  Device: $localize`Device`,
};
